import { render, staticRenderFns } from "./TMultiselectButton.vue?vue&type=template&id=365c1611&scoped=true&"
import script from "./TMultiselectButton.vue?vue&type=script&lang=js&"
export * from "./TMultiselectButton.vue?vue&type=script&lang=js&"
import style0 from "./TMultiselectButton.vue?vue&type=style&index=0&id=365c1611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c1611",
  null
  
)

/* custom blocks */
import block0 from "./TMultiselectButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports